<template>

    <div>

        <div class='fileBlock bg-grey-1 shadow-3 q-mb-md gt-xs'>
            <div class=" bg-purple-6 text-white q-pa-md full-width row no-wrap justify-between">
                
                <div>
                    <q-btn icon='cancel' inverted dense outline color='white' class='q-mr-sm' @click='deleteFromBill'/>
                    Заказ № {{order.main_id}} | {{contragentName}}
                </div>
                
                <div>Менеджер заказа: {{managerName}}</div>
            </div>
            <div class="row no-wrap items-center">
                <div class="col-6 q-pa-sm q-body-1">
                    <div class='q-ma-md'>Направление: <span class='q-subheading text-weight-bold text-truncate uppercase'> {{directionName}}</span></div>
                    <div class='q-ma-md'>Размер <span class='q-caption text-grey-7'>(ширина х высота)</span>: <span class='q-subheading text-weight-bold text-truncate'> {{imageSize}}</span></div>
                    <div class='q-ma-md'>Материал: <span class='q-subheading text-weight-bold text-truncate'> {{materialName}}</span></div>
                    <div class='q-ma-md'>Количество: <span class='q-subheading text-weight-bold text-truncate'> {{options.number}} шт</span></div>
                    <!-- Тут будем выводить стоимости -->
                    <div class='fileBlock q-pa-sm bg-grey-2 full-width'>
                        <div  class='q-ma-xs'>Цена за кв.м.: <span class='q-subheading text-weight-bold text-truncate'>{{options.printForMeterCost}} р.</span></div>
                        <div class='q-ma-xs'>Печать: <span class='q-subheading text-weight-bold text-truncate'> {{options.width}} x {{options.height}} x {{options.printForMeterCost}} = {{printCost.cost}} р. </span></div>
                        <div class='q-ma-xs'>Постобработка: <span class='q-subheading text-weight-bold text-truncate'>{{options.postCost}} р.</span></div>
                        <div class='q-ma-xs'>Доп.работы: <span class='q-subheading text-weight-bold text-truncate'>{{printCost.extWork}} р.</span></div>
                        <div class='q-ma-xs q-mt-md q-subheading text-weight-bold text-truncate text-red-10'>ИТОГО ЗА {{options.number}} шт: {{printCost.allCost}} р.</div>
                    </div>
                </div>
                <div class="col-6 text-center q-pa-sm">
                    <img :src="options.preview_1" class="preview-image">                    
                </div>
            </div>
        </div>
    </div>

</template>

<script>
/* eslint-disable */
export default {
    name : 'billDialogFile',
    
    props : {
        order : {
            type: Object,
            requered: true,
        },
    },

    data() {
        return {
            postItog : 0,
            options : null,
        }
    },

    created() {
        // console.log(this.order);
        this.options = JSON.parse(this.order.options);

    },
    
    methods : {
        deleteFromBill() {  //удаляем заказ из счета
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Вы действительно хотите удалить заказ №'+this.order.main_id+' из счета?',
                color: 'primary',
                ok: 'Да, удалить', // takes i18n value, or String for "OK" button label
                cancel: true, // takes i18n value, or String for "Cancel" button label
            })
            .then(()=>{
                this.$store.dispatch('deleteFromBill', this.order.main_id)
                .then()
                .catch();
            })
            .catch();
        }
    },

    computed : {
        printCost() {
            let cost = this.options.width*this.options.height*this.options.printForMeterCost;
            //console.log(this.options.printCost);
            let post_cost = 0;
            // console.log(this.options);
            if (this.options.post != null) {
                let filePost = this.options.post;
                for (var key in filePost) {
                    // console.log(filePost['space']);
                    for (var i = 0; i<filePost[key].length; i++) { //идем по всем значениям

                        var p = this.$store.getters.getPostPrice(filePost[key][i]);
                        if (p != undefined) {
                            if (key == 'space') { // если обработка по площади
                                post_cost += this.options.width*this.options.height*p.cost;
                                // console.log('считаем');
                            } else { //если по периметру
                                let l = this.options.height;
                                if ((key=='top')||(key=='bottom')) l = this.options.width;
                                post_cost += p.cost*l;
                            }

                        }
                    }
                }
                this.postItog = Math.round(post_cost*100)/100;
            } else {
                this.postItog = 0;
            }
            let extWork = 0;
            if (this.options.extWork != null) {
                this.options.extWork.forEach(element => {
                    extWork += element.eachNumber ? element.cost*this.options.number : element.cost;
                });
            }
            // let allCost = Math.round((cost+post_cost)*this.options.number);
            let allCost = this.order.cost;
            this.order.allCost = allCost;

            // this.$store.commit('refreshOrder', this.order); //устанавливаем окончательную стоимость за файл

            return {cost : Math.round(cost), allCost : allCost, post :  Math.round(post_cost*100)/100, extWork : extWork};
        },

        contragentName(){
            let c = this.$store.getters.getContragentById(this.order.contragent);
            let name = '';
            if (c != undefined) {
                name = c.name;
            }
            return name;
        },
        managerName(){
            let c = this.$store.getters.getUserById(this.order.manager);
            let name = 'Не задан';
            if (c != undefined) {
                name = c.name;
            }
            return name;
        },
        directionName() {
            let d = this.$store.getters.getDirectionById(this.options.stanok);
            let name = 'Не определено';
            if (d != undefined) {
                name = d.name;
            }
            return name;
        },
        imageSize(){
           return this.options.width + ' x ' +this.options.height + ' м';
        },

        materialName() {
            let m = this.$store.getters.getMaterialById(this.options.material);
            let name = 'Материал не задан';
            if (m != undefined) {
                name = m.name;
            }
            return name;
        }

    },

}
</script>
<style lang="scss" scoped>
    .fileBlock {
        border : 1px solid rgb(194, 194, 194);
    }
    .preview-image {
        padding: 10px;
        border:1px solid rgb(212, 212, 212);
        background: white;
        max-width: 400px;
        width:auto;
    }
</style>
